<script lang="tsx">
import { Popover, Table, type TableColumnType } from 'ant-design-vue'
import { type PropType, defineComponent } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Tag } from '-/Common/Tag'
const [name, bem] = createNamespace('PopoverTable')
export default defineComponent({
  name,
  props: {
    dataSource: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    columns: {
      type: Array as PropType<TableColumnType[]>,
      default: () => []
    },
    height: {
      type: [Number, String] as PropType<number | string>,
      default: 300
    },
    width: {
      type: [Number, String] as PropType<number | string>,
      default: '800px'
    },
    placement: {
      type: String as PropType<string>,
      default: 'topLeft'
    },
    popoverProps: {
      type: Object as PropType<any>,
      default: () => ({})
    }
  },
  setup(props, { attrs, slots }) {
    const renderCount = () => (
      <Tag class={bem()} color='processing'>
        {props.dataSource.length}
      </Tag>
    )
    const renderContent = () => (
      <div style={{ width: props.width }}>
        <Table dataSource={props.dataSource} columns={props.columns} scroll={{ x: 'max-content', y: props.height }} {...attrs} />
      </div>
    )

    const renderPopover = slot => (
      <Popover {...props.popoverProps} placement={props.placement} content={renderContent()}>
        {slot}
      </Popover>
    )
    return () => (slots?.default ? renderPopover(slots.default()) : props.dataSource.length > 0 ? renderPopover(renderCount()) : renderCount())
  }
})
</script>
<style lang="less">
.popover-table {
  cursor: pointer;

  &__title {
    font-weight: 900;
    font-size: 18px;
    line-height: 36px;
  }
}
</style>
